import { reactive, watch } from 'vue'

// Load initial data from localStorage
const storedCart = JSON.parse(localStorage.getItem('cartItems') || '[]')
const storedWishlist = JSON.parse(localStorage.getItem('wishlistItems') || '[]')

export const cartStore = reactive({
  cartItems: storedCart,
  wishlistItems: storedWishlist,

  addToCart(product) {
    if (!this.cartItems.some(item => item.id === product.id)) {
      this.cartItems.push({ ...product, quantity: 1 })
    }
  },

  toggleWishlist(productId) {
    if (this.wishlistItems.includes(productId)) {
      this.wishlistItems = this.wishlistItems.filter(id => id !== productId)
    } else {
      this.wishlistItems.push(productId)
    }
  },

  isInCart(productId) {
    return this.cartItems.some(item => item.id === productId)
  },

  isInWishlist(productId) {
    return this.wishlistItems.includes(productId)
  }
})

// ✅ Watch for changes and save to localStorage
watch(
  () => cartStore.cartItems,
  (newVal) => {
    localStorage.setItem('cartItems', JSON.stringify(newVal))
  },
  { deep: true }
)

watch(
  () => cartStore.wishlistItems,
  (newVal) => {
    localStorage.setItem('wishlistItems', JSON.stringify(newVal))
  },
  { deep: true }
)
